import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";
import LotPositioin from '../../../page/MillstageEntry/LotPositioin/LotPositioin';

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get('authToken');
const YearDatabase = Cookies.get('MSdatabase');


export const AllFilter = createAsyncThunk(
    'MillStageWeb/AllFilter',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseURL}/MillStageWeb/AllFilter`, {
                DataBase: YearDatabase
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const ProcessTypeInsert = createAsyncThunk(
    "MillStageWeb/ProcessTypeInsert",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessTypeInsert`,
                {
                    DataBase: YearDatabase,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProdConsRecipeInsert = createAsyncThunk(
    "MillStageWeb/ProdConsRecipeInsert",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProdConsRecipeInsert`,
                {
                    DataBase: YearDatabase,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProdConsRecipeUpdate = createAsyncThunk(
    "MillStageWeb/ProdConsRecipeUpdate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProdConsRecipeUpdate`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProdConsRecipeDelete = createAsyncThunk(
    "MillStageWeb/ProdConsRecipeDelete",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProdConsRecipeDelete`,
                {
                    DataBase: YearDatabase,
                    MainID: data.MainID
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProdConsRecipeShowAll = createAsyncThunk(
    'MillStageWeb/ProdConsRecipeShowAll',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseURL}/MillStageWeb/ProdConsRecipeShowAll`, {
                DataBase: YearDatabase,
                EntryTypeID: data.EntryTypeID
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const ProdConsRecipeShowOne = createAsyncThunk(
    "MillStageWeb/ProdConsRecipeShowOne",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProdConsRecipeShowOne`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID || "",
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProcessTypeShowAll = createAsyncThunk(
    'MillStageWeb/ProcessTypeShowAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseURL}/MillStageWeb/ProcessTypeShowAll`, {
                DataBase: YearDatabase
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const ProcessTypeShowOne = createAsyncThunk(
    "MillStageWeb/ProcessTypeShowOne",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessTypeShowOne`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID || "",
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProcessTypeUpdate = createAsyncThunk(
    "MillStageWeb/ProcessTypeUpdate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessTypeUpdate`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProcessTypeDelete = createAsyncThunk(
    "MillStageWeb/ProcessTypeDelete",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessTypeDelete`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

// ---------------Process Quality---------------


export const QualityMstShowAll = createAsyncThunk(
    'MillStageWeb/QualityMstShowAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseURL}/MillStageWeb/QualityMstShowAll`, {
                DataBase: YearDatabase
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);


export const QualityMstShowOne = createAsyncThunk(
    "MillStageWeb/QualityMstShowOne",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/QualityMstShowOne`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID || "",
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const QualityMstInsert = createAsyncThunk(
    "MillStageWeb/QualityMstInsert",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/QualityMstInsert`,
                {
                    DataBase: YearDatabase,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);


export const QualityMstUpdate = createAsyncThunk(
    "MillStageWeb/QualityMstUpdate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/QualityMstUpdate`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const QualityMstDelete = createAsyncThunk(
    "MillStageWeb/QualityMstDelete",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/QualityMstDelete`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProcessQualityShowAll = createAsyncThunk(
    'MillStageWeb/ProcessQualityShowAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseURL}/MillStageWeb/ProcessQualityShowAll`, {
                DataBase: YearDatabase
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);


export const ProcessQualityShowOne = createAsyncThunk(
    "MillStageWeb/ProcessQualityShowOne",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessQualityShowOne`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID || "",
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProcessQualityInsert = createAsyncThunk(
    "MillStageWeb/ProcessQualityInsert",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessQualityInsert`,
                {
                    DataBase: YearDatabase,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);


export const ProcessQualityUpdate = createAsyncThunk(
    "MillStageWeb/ProcessQualityUpdate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessQualityUpdate`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProcessQualityDelete = createAsyncThunk(
    "MillStageWeb/ProcessQualityDelete",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessQualityDelete`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);


// --------------Process Master--------------


export const ProcessMstInsert = createAsyncThunk(
    "MillStageWeb/ProcessMstInsert",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessMstInsert`,
                {
                    DataBase: YearDatabase,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProcessMstShowAll = createAsyncThunk(
    'MillStageWeb/ProcessMstShowAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseURL}/MillStageWeb/ProcessMstShowAll`, {
                DataBase: YearDatabase
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const ProcessMstShowOne = createAsyncThunk(
    "MillStageWeb/ProcessMstShowOne",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessMstShowOne`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID || "",
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProcessMstUpdate = createAsyncThunk(
    "MillStageWeb/ProcessMstUpdate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessMstUpdate`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const ProcessMstDelete = createAsyncThunk(
    "MillStageWeb/ProcessMstDelete",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/ProcessMstDelete`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);


// --------------SubProcess---------------

export const MatchingMstInsert = createAsyncThunk(
    "MillStageWeb/MatchingMstInsert",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/MatchingMstInsert`,
                {
                    DataBase: YearDatabase,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const SubProcessInsert = createAsyncThunk(
    "MillStageWeb/SubProcessInsert",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/SubProcessInsert`,
                {
                    DataBase: YearDatabase,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const MatchingMstShowAll = createAsyncThunk(
    'MillStageWeb/MatchingMstShowAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseURL}/MillStageWeb/MatchingMstShowAll`, {
                DataBase: YearDatabase
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const MatchingMstShowOne = createAsyncThunk(
    "MillStageWeb/MatchingMstShowOne",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/MatchingMstShowOne`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID || "",
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const MatchingMstUpdate = createAsyncThunk(
    "MillStageWeb/MatchingMstUpdate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/MatchingMstUpdate`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                    master: data?.master,
                    detail: data?.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const MatchingMstDelete = createAsyncThunk(
    "MillStageWeb/MatchingMstDelete",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/MatchingMstDelete`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const SubProcessShowAll = createAsyncThunk(
    'MillStageWeb/SubProcessShowAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseURL}/MillStageWeb/SubProcessShowAll`, {
                DataBase: YearDatabase
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const SubProcessShowOne = createAsyncThunk(
    "MillStageWeb/SubProcessShowOne",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/SubProcessShowOne`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID || "",
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const SubProcessUpdate = createAsyncThunk(
    "MillStageWeb/SubProcessUpdate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/SubProcessUpdate`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                    master: data.master,
                    detail: data.detail,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const SubProcessDelete = createAsyncThunk(
    "MillStageWeb/SubProcessDelete",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/SubProcessDelete`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);




// -----------------------Lot Positioin-------------------

export const LotNoSearch = createAsyncThunk(
    "MillStageWeb/LotNoSearch",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/LotNoSearch`,
                {
                    DataBase: YearDatabase,
                    LotOpt: data?.LotOpt,
                    LotNo: data?.LotNo,
                    GroupID: data?.GroupID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const LotPosition12 = createAsyncThunk(
    "MillStageWeb/LotPosition",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/LotPosition`,
                {
                    DataBase: YearDatabase,
                    InwardID: data?.InwardID,
                    InwFirmId: data?.InwFirmId,
                    InwAcYear: data?.InwAcYear,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const LotTakaDetail = createAsyncThunk(
    "MillStageWeb/LotTakaDetail",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/LotTakaDetail`,
                {
                    DataBase: YearDatabase,
                    InwardID: data?.InwardID,
                    TransID: data?.TransID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

// ---------------------TransDetail module-------------------

export const TransFilters = createAsyncThunk(
    "MillStageWeb/TransFilters",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/TransFilters`,
                {
                    DataBase: YearDatabase,
                    FirmID: data?.FirmID,
                    TransTypeID: data?.TransTypeID,
                    ProcessMstID: data?.ProcessMstID ? data?.ProcessMstID : 0,
                    ProcessTypeID: data?.ProcessTypeID ? data?.ProcessTypeID : 0,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const TransShowAll = createAsyncThunk(
    "MillStageWeb/TransShowAll",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/TransShowAll`,
                {
                    DataBase: YearDatabase,
                    TransTypeID: data?.TransTypeID,
                    ProcessMstID: data?.ProcessMstID,
                    FromDate: data?.FromDate,
                    ToDate: data?.ToDate,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const TransShowOne = createAsyncThunk(
    "MillStageWeb/TransShowOne",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/TransShowOne`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const LotPendHelp = createAsyncThunk(
    "MillStageWeb/LotPendHelp",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/LotPendHelp`,
                {
                    DataBase: YearDatabase,
                    FirmID: data?.FirmID,
                    TransTypeID: data?.TransTypeID ? data?.TransTypeID : 0,
                    SubStageID: data?.SubStageID ? data?.SubStageID : 0,
                    PartyID: data?.PartyID ? data?.PartyID : 0,
                    QualityID: data?.QualityID ? data?.QualityID : 0,
                    GroupID: data?.GroupID ? data?.GroupID : 0,
                    ProcessMstID: data?.ProcessMstID ? data?.ProcessMstID : 0,
                    RecvBy: data?.RecvBy ? data?.RecvBy : 0,
                    LotNo: data?.LotNo ? data?.LotNo : "",
                    MasterWise: data?.MasterWise ? data?.MasterWise : 0,
                    Admin: data?.Admin ? data?.Admin : 0,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const TransDelete = createAsyncThunk(
    "MillStageWeb/TransDelete",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/TransDelete`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const TransInsert = createAsyncThunk(
    "MillStageWeb/TransInsert",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/TransInsert`,
                {
                    DataBase: YearDatabase,
                    master: data?.master,
                    detail: data?.detail,
                    subdetail: data?.subdetail,
                    recdetail: data?.recdetail,
                    exflds: data?.exflds,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;

        } catch (error) {
            console.log("========== TransInsert API ERROR ==========");
            console.log("Status:", error?.response?.status);
            console.log("Response:", error?.response?.data);
            console.log("Message:", error?.message);

            return rejectWithValue(
                error?.response?.data || error?.message || "Network Error"
            );
        }
    }
);

export const TransUpdate = createAsyncThunk(
    "MillStageWeb/TransUpdate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/TransUpdate`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                    TransTypeID: data?.TransTypeID,
                    ProcessMstID: data?.ProcessMstID,
                    FromDate: data?.FromDate,
                    ToDate: data?.ToDate,
                    master: data?.master,
                    detail: data?.detail,
                    subdetail: data?.subdetail,
                    recdetail: data?.recdetail,
                    exflds: data?.exflds,

                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;

        } catch (error) {
            console.log("========== TransInsert API ERROR ==========");
            console.log("Status:", error?.response?.status);
            console.log("Response:", error?.response?.data);
            console.log("Message:", error?.message);

            return rejectWithValue(
                error?.response?.data || error?.message || "Network Error"
            );
        }
    }
);

export const TransSubDtlInsertHelp = createAsyncThunk(
    "MillStageWeb/TransSubDtlInsertHelp",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/TransSubDtlInsertHelp`,
                {
                    DataBase: YearDatabase,
                    FirmID: data?.FirmID,
                    TransTypeID: data?.TransTypeID ? data?.TransTypeID : "",
                    FromStageID: data?.FromStageID ? data?.FromStageID : "",
                    FromSubStageID: data?.FromSubStageID ? data?.FromSubStageID : "",
                    ToSubStageID: data?.ToSubStageID ? data?.ToSubStageID : "",
                    InwCode: data?.InwCode ? data?.InwCode : "",
                    TransDtlID: data?.TransDtlID ? data?.TransDtlID : "",
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const GetStageSrNo = createAsyncThunk(
    "MillStageWeb/GetStageSrNo",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/GetStageSrNo`,
                {
                    DataBase: YearDatabase,
                    MainID: data?.MainID,
                    Date: data?.Date,
                    TransTypeID: data?.TransTypeID,
                    FirmID: data?.FirmID,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const AppSetupDetail = createAsyncThunk(
    "MillStageWeb/AppSetupDetail",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/AppSetupDetail`,
                {
                    FirmID: data?.FirmID,
                    DataBase: YearDatabase,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const GetAvgRate = createAsyncThunk(
    "MillStageWeb/GetAvgRate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/GetAvgRate`,
                {
                    ToDate: data?.ToDate,
                    ItemID: data?.ItemID,
                    DataBase: YearDatabase,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);

export const TransDeleteCheck = createAsyncThunk(
    "MillStageWeb/TransDeleteCheck",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseURL}/MillStageWeb/TransDeleteCheck`,
                {
                    MainID: data?.MainID,
                    DataBase: YearDatabase,
                },
                {
                    headers: {
                        token,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : "Network Error"
            );
        }
    }
);


const MillstageEntrySlice = createSlice({
    name: 'CollectionMan',
    initialState: {
        AllFilterdata: null,

        ProcessTypeShowOnedata: null,
        ProcessTypeShowAlldata: null,

        ProcessQualityShowAlldata: null,
        QualityMstShowAlldata: null,
        ProcessQualityShowOnedata: null,
        QualityMstShowOnedata: null,

        ProcessMstShowOnedata: null,
        ProcessMstShowAlldata: null,

        SubProcessShowAlldata: null,
        MatchingMstShowAlldata: null,
        SubProcessShowOnedata: null,
        ProdConsRecipeShowAlldata: null,
        ProdConsRecipeShowOnedata: null,

        LotPositiondata: null,
        LotTakaDetaildata: null,
        LotNoSearchdata: null,

        TransFiltersdata: null,
        TransShowAlldata: null,
        TransShowOnedata: null,

        TransSubDtlInsertHelpdata: null,
        GetStageSrNodata: null,

        LotPendHelpdata: null,
        AppSetupDetaildata1: null,

        TransUpdatedata: null,

        GetAvgRatedata: null,

        TransDeleteCheckdata: null,

    },
    reducers: {
        clearPartiesError: (state) => {
            state.error = null;
        },
        clearTransFilters: (state) => {
            state.TransFiltersdata.Treatment = [];
            state.TransFiltersdata.Recipe = [];
        },
    },
    extraReducers: (builder) => {

        builder
            .addCase(AllFilter.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(AllFilter.fulfilled, (state, action) => {
                state.loading = false;
                state.AllFilterdata = action.payload;
            })
            .addCase(AllFilter.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(ProcessTypeShowAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(ProcessTypeShowAll.fulfilled, (state, action) => {
                state.loading = false;
                state.ProcessTypeShowAlldata = action.payload;
            })
            .addCase(ProcessTypeShowAll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(ProcessTypeShowOne.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ProcessTypeShowOne.fulfilled, (state, action) => {
                state.loading = false;
                state.ProcessTypeShowOnedata = action.payload;
            })
            .addCase(ProcessTypeShowOne.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(QualityMstShowAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(QualityMstShowAll.fulfilled, (state, action) => {
                state.loading = false;
                state.QualityMstShowAlldata = action.payload;
            })
            .addCase(QualityMstShowAll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(QualityMstShowOne.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(QualityMstShowOne.fulfilled, (state, action) => {
                state.loading = false;
                state.QualityMstShowOnedata = action.payload;
            })
            .addCase(QualityMstShowOne.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(ProcessQualityShowAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ProcessQualityShowAll.fulfilled, (state, action) => {
                state.loading = false;
                state.ProcessQualityShowAlldata = action.payload;
            })
            .addCase(ProcessQualityShowAll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(ProcessQualityShowOne.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ProcessQualityShowOne.fulfilled, (state, action) => {
                state.loading = false;
                state.ProcessQualityShowOnedata = action.payload;
            })
            .addCase(ProcessQualityShowOne.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(ProcessMstShowAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ProcessMstShowAll.fulfilled, (state, action) => {
                state.loading = false;
                state.ProcessMstShowAlldata = action.payload;
            })
            .addCase(ProcessMstShowAll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(ProcessMstShowOne.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ProcessMstShowOne.fulfilled, (state, action) => {
                state.loading = false;
                state.ProcessMstShowOnedata = action.payload;
            })
            .addCase(ProcessMstShowOne.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(SubProcessShowAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(SubProcessShowAll.fulfilled, (state, action) => {
                state.loading = false;
                state.SubProcessShowAlldata = action.payload;
            })
            .addCase(SubProcessShowAll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(SubProcessShowOne.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(SubProcessShowOne.fulfilled, (state, action) => {
                state.loading = false;
                state.SubProcessShowOnedata = action.payload;
            })
            .addCase(SubProcessShowOne.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(MatchingMstShowAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MatchingMstShowAll.fulfilled, (state, action) => {
                state.loading = false;
                state.MatchingMstShowAlldata = action.payload;
            })
            .addCase(MatchingMstShowAll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(MatchingMstShowOne.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MatchingMstShowOne.fulfilled, (state, action) => {
                state.loading = false;
                state.MatchingMstShowOnedata = action.payload;
            })
            .addCase(MatchingMstShowOne.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(ProdConsRecipeShowAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ProdConsRecipeShowAll.fulfilled, (state, action) => {
                state.loading = false;
                state.ProdConsRecipeShowAlldata = action.payload;
            })
            .addCase(ProdConsRecipeShowAll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(ProdConsRecipeShowOne.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ProdConsRecipeShowOne.fulfilled, (state, action) => {
                state.loading = false;
                state.ProdConsRecipeShowOnedata = action.payload;
            })
            .addCase(ProdConsRecipeShowOne.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(LotPosition12.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(LotPosition12.fulfilled, (state, action) => {
                state.loading = false;
                state.LotPositiondata = action.payload;
            })
            .addCase(LotPosition12.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(LotTakaDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(LotTakaDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.LotTakaDetaildata = action.payload;
            })
            .addCase(LotTakaDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(LotNoSearch.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(LotNoSearch.fulfilled, (state, action) => {
                state.loading = false;
                state.LotNoSearchdata = action.payload;
            })
            .addCase(LotNoSearch.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(TransShowAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(TransShowAll.fulfilled, (state, action) => {
                state.loading = false;
                state.TransShowAlldata = action.payload;
            })
            .addCase(TransShowAll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(TransShowOne.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(TransShowOne.fulfilled, (state, action) => {
                state.loading = false;
                state.TransShowOnedata = action.payload;
            })
            .addCase(TransShowOne.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(TransUpdate.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(TransUpdate.fulfilled, (state, action) => {
                state.loading = false;
                state.TransUpdatedata = action.payload;
            })
            .addCase(TransUpdate.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(TransInsert.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(TransInsert.fulfilled, (state, action) => {
                state.loading = false;
                state.TransInsertdata = action.payload;
            })
            .addCase(TransInsert.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })



            .addCase(TransFilters.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(TransFilters.fulfilled, (state, action) => {
                state.loading = false;
                state.TransFiltersdata = action.payload;
            })
            .addCase(TransFilters.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(LotPendHelp.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(LotPendHelp.fulfilled, (state, action) => {
                state.loading = false;
                state.LotPendHelpdata = action.payload;
            })
            .addCase(LotPendHelp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(TransSubDtlInsertHelp.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(TransSubDtlInsertHelp.fulfilled, (state, action) => {
                state.loading = false;
                state.TransSubDtlInsertHelpdata = action.payload;
            })
            .addCase(TransSubDtlInsertHelp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(GetStageSrNo.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetStageSrNo.fulfilled, (state, action) => {
                state.loading = false;
                state.GetStageSrNodata = action.payload;
            })
            .addCase(GetStageSrNo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })



            .addCase(AppSetupDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(AppSetupDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.AppSetupDetaildata = action.payload;
            })
            .addCase(AppSetupDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })



            .addCase(GetAvgRate.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAvgRate.fulfilled, (state, action) => {
                state.loading = false;
                state.GetAvgRatedata = action.payload;
            })
            .addCase(GetAvgRate.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(TransDeleteCheck.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(TransDeleteCheck.fulfilled, (state, action) => {
                state.loading = false;
                state.TransDeleteCheckdata = action.payload;
            })
            .addCase(TransDeleteCheck.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })






    },
});

export const { clearPartiesError, clearTransFilters } = MillstageEntrySlice.actions;
export default MillstageEntrySlice.reducer;